export const userSignUpValidationMessages = {
  DUPLICATE_BUSINESS_EMAIL: 'DUPLICATE_BUSINESS_EMAIL',
  DUPLICATE_GSTNO: 'DUPLICATE_GSTNO',
  DUPLICATE_PAN: 'DUPLICATE_PAN',
  DUPLICATE_CIN: 'DUPLICATE_CIN',
  DUPLICATE_TELEPHONE: 'DUPLICATE_TELEPHONE',
  DUPLICATE_EMPLOYEE_MOBILE: 'DUPLICATE_EMPLOYEE_MOBILE'
};
